import { render } from "./Akun.vue?vue&type=template&id=c56ad86e&scoped=true"
import script from "./Akun.vue?vue&type=script&lang=js"
export * from "./Akun.vue?vue&type=script&lang=js"

import "./Akun.vue?vue&type=style&index=0&id=c56ad86e&scoped=true&lang=css"
import "./Akun.vue?vue&type=style&index=1&id=c56ad86e&scoped=true&lang=css"

import exportComponent from "D:\\project\\vue\\family-notes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c56ad86e"]])

export default __exports__